export default __webpack_public_path__ + "static/media/nftCard.ec17cbfb.png";